import { unwrap } from "@sagot/api-client";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import type { BillingConfigOut } from "./api-types";
import { wsKeys } from "./query-keys";

/**
 * `GET /v1/billing/config`: per gateway, the mode it runs in (`live` | `test` | `mock`) and that
 * mode's browser-safe public key (DEC-065). Read at runtime so flipping a gateway's mode on the
 * server needs no rebuild and the browser key always matches the server.
 */
export function useBillingConfig(enabled = true): UseQueryResult<BillingConfigOut> {
  const api = useApi();
  const wsId = useWorkspaceId();
  return useQuery({ queryKey: wsKeys.billingConfig(wsId), queryFn: () => unwrap(api.GET("/v1/billing/config")), staleTime: 5 * 60_000, enabled });
}
